import { Dropdown, IDropdownOption } from "office-ui-fabric-react";
import React, { Fragment, useCallback, useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { DecodeDateRange, getLocalAuthorityOptions, getRegionalPartnershipOptions, getSchoolOptions, getSchoolTypeOptions } from '../../../decode-filters';
import { WsDecodeContext } from "../DecodeContext";

import moment from 'moment-timezone';

import { DatePickerInput } from '@mantine/dates';
import { getBoardGroupList } from "../../../decode-helpers";



/*
use CountUp for metrics
.ws-deliver-decode-score-bar-title-ratio
*/





type WsDecodeFiltersProps = {
  defaultValues: {
    // DateRange?: string;
    regionalPartnershipId?: string;
    localAuthorityId?: string;
    schoolTypeId?: string;
    schoolId?: string;
  }
  visible: {
    BoardGroup?: boolean;
    DateRange?: boolean;
    RegionalPartnership?: boolean;
    LocalAuthority?: boolean;
    SchoolType?: boolean;
    School?: boolean;
  }
};




const WsDecodeFilters = (props: WsDecodeFiltersProps) => {

  const decodeContext = useContext(WsDecodeContext);
  const history = useHistory();



  const [ dateRangeValue, setDateRange ] = useState<[ Date | null, Date | null]>(decodeContext?.selectedDateRange ? [ decodeContext.selectedDateRange.start, decodeContext.selectedDateRange.end ] : [ null, null ]);




  useEffect(() => {

    if (props.defaultValues.regionalPartnershipId || props.defaultValues.regionalPartnershipId === '') {
      decodeContext?.setSelectedRegionalPartnershipId(props.defaultValues.regionalPartnershipId);
    }

  }, [ props.defaultValues.regionalPartnershipId ]);



  useEffect(() => {

    if (props.defaultValues.localAuthorityId || props.defaultValues.localAuthorityId === '') {
      decodeContext?.setSelectedLocalAuthorityId(props.defaultValues.localAuthorityId);
    }

  }, [ props.defaultValues.localAuthorityId ]);



  useEffect(() => {

    if (props.defaultValues.schoolTypeId || props.defaultValues.schoolTypeId === '') {
      decodeContext?.setSelectedSchoolId(props.defaultValues.schoolTypeId);
    }

  }, [ props.defaultValues.schoolTypeId ]);



  useEffect(() => {

    if (props.defaultValues.schoolId || props.defaultValues.schoolId === '') {
      decodeContext?.setSelectedSchoolId(props.defaultValues.schoolId);
    }

  }, [ props.defaultValues.schoolId ]);








  useEffect(() => {

    if (dateRangeValue && dateRangeValue[0] && dateRangeValue[1]) {
      decodeContext?.setSelectedDateRange({
        start: dateRangeValue[0],
        end:   dateRangeValue[1]
      });
    }

  }, [ dateRangeValue ]);



  return (
    <>
      <div className="ws-deliver-decode-page-filters">

        {
          props.visible.BoardGroup
          &&
          <>
            <div className="ws-deliver-decode-page-filters-column" style={{ position: 'absolute', top: '-1px', left: '0px' }}>
              <Dropdown

                label={`Board Group`}

                options={getBoardGroupList().map((boardGroup) => {
                  return {
                    key:  boardGroup.id,
                    text: boardGroup.name
                  };
                })}

                onChange={(event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption | undefined, index?: number | undefined): void => {
                  if (option) {
                    decodeContext?.setSelectedBoardGroupId(`${option.key}`);

                    // @agentsNote Board-detail URL IDs override the selected group; return to the main dashboard so the new group takes effect. The router supplies the /v1 basename.
                    if (history.location.pathname !== '/deliver/decode') {
                      history.push('/deliver/decode');
                    }
                  }
                }}
                placeholder="Select Board Group"
                selectedKey={decodeContext?.selectedBoardGroupId}
                styles={{
                  dropdown: { width: 200 }
                }}
              />
            </div>
          </>
        }

        {/* <div className="ws-deliver-decode-page-filters-column" style={{ paddingTop: '35px', paddingRight: '5px' }}>
          <b>Filter</b>
        </div> */}

        {
          props.visible.DateRange
          &&
          <>
            <div className="ws-deliver-decode-page-filters-column">
              <DatePickerInput
                type="range"
                label="Date Range"
                placeholder="Pick Date Range"
                value={dateRangeValue}
                onChange={setDateRange}
                mx="auto"
                maw={400}
                // monthLabelFormat="MMM YYYY"
                valueFormat="MMM D, YYYY"
              />
            </div>
          </>
        }

        {
          props.visible.RegionalPartnership
          &&
          <>
            <div className="ws-deliver-decode-page-filters-column">
              <Dropdown

                // label={`Regional Partnership`}
                label={`Organisation`}

                options={getRegionalPartnershipOptions()}
                onChange={(event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption | undefined, index?: number | undefined): void => {
                  if (option) {

                    decodeContext?.setSelectedRegionalPartnershipId(`${option.key}`);

                    decodeContext?.setSelectedLocalAuthorityId('');

                    decodeContext?.setSelectedSchoolTypeId('');

                    decodeContext?.setSelectedSchoolId('');

                  }
                }}
                placeholder="Select Organisation"
                selectedKey={decodeContext?.selectedRegionalPartnershipId}
                styles={{
                  dropdown: { width: 150 }
                }}
              />
            </div>
          </>
        }

        {
          props.visible.LocalAuthority
          &&
          <>

            <div className="ws-deliver-decode-page-filters-column">
              <Dropdown
                label={`Business Unit`}

                options={getLocalAuthorityOptions(decodeContext?.selectedRegionalPartnershipId)}

                onChange={(event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption | undefined, index?: number | undefined): void => {
                  if (option) {
                    decodeContext?.setSelectedLocalAuthorityId(`${option.key}`);
                  }
                }}
                placeholder="Select Business Unit"
                selectedKey={decodeContext?.selectedLocalAuthorityId}
                styles={{
                  dropdown: { width: 260 }
                }}
              />
            </div>
          </>
        }

        {
          props.visible.SchoolType
          &&
          <>

            <div className="ws-deliver-decode-page-filters-column">

              <Dropdown

                // label={`School Type`}
                // label={`L2 Business Unit`}
                label={`Personas`}

                // options={getSchoolTypeOptions(decodeContext?.selectedRegionalPartnershipId || '')}

                options={[

                  { key: '',  text: 'All' },
                  { key: '1', text: 'Senior Management' },
                  { key: '2', text: 'Leadership' },
                  { key: '3', text: 'Remote Worker' },
                  { key: '4', text: 'Developer' },
                  { key: '5', text: 'Customer Facing' },
                  { key: '6', text: 'Legal' },

                ]}

                onChange={(event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption | undefined, index?: number | undefined): void => {
                  if (option) {
                    decodeContext?.setSelectedSchoolTypeId(`${option.key}`);
                  }
                }}
                placeholder=""
                selectedKey={decodeContext?.selectedSchoolTypeId}
                styles={{
                  dropdown: { width: 170 }
                }}
              />

            </div>
          </>
        }

        {
          props.visible.School
          &&
          <>
            <div className="ws-deliver-decode-page-filters-column">
              <Dropdown
                label={`School`}
                options={getSchoolOptions(decodeContext?.selectedRegionalPartnershipId || '', decodeContext?.selectedLocalAuthorityId || '')}
                onChange={(event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption | undefined, index?: number | undefined): void => {
                  if (option) {
                    decodeContext?.setSelectedSchoolId(`${option.key}`);
                  }
                }}
                placeholder="Select School"
                selectedKey={decodeContext?.selectedSchoolId}
                styles={{
                  dropdown: { width: 350 }
                }}
              />
            </div>
          </>
        }

      </div>
    </>
  );
};




export {
  WsDecodeFilters
};
